import { Button as MuiButton } from "@mui/material";
import styled from "styled-components";

export const Container: ReturnType<typeof styled.main> = styled.main`
  display: flex;
  flex-direction: column;
  width: 430px;
  background: ${({ theme }) => theme.palette.brandGray.light};
  padding: 20px;
`;
export const TitleBox = styled.div`
  width: 100%;
`;
export const TextContainer = styled.div`
  display: block;
`;

export const ButtonBox = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const Button = styled(MuiButton)`
  min-width: 110px;
  height: 40px;
  align-items: center;
  padding: 0 0;
  margin: 5px;
`;

export const WideButton = styled(MuiButton)`
  min-width: 200px;
  height: 40px;
  align-items: center;
  padding: 0 0;
  margin: 5px;
`;

export const HistoryButton = styled(WideButton)`
  margin: 5px 0px 0px;
`;

// Loading spinner from Mui Lab (Mui 5) was not working
export const Loader = styled.div`
  &.animated {
    width: 12px;
    height: 12px;
    border: 2px solid #fff;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    margin: 0.25rem;
  }
  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
